import { csvMappingApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CSV_MAPPING_ACTION_TYPE = createNamedActions('csvMapping', {
  GET_CSV_MAPPING_PROPS: 'GET_CSV_MAPPING_PROPS',
  GET_CSV_MAPPING_METADATA: 'GET_CSV_MAPPING_METADATA',
  CREATE_CSV_MAPPING_EXAMPLE_FILE: 'CREATE_CSV_MAPPING_EXAMPLE_FILE',
  EDIT_CSV_MAPPING_PROPS: 'EDIT_CSV_MAPPING_PROPS',
  RESET_CSV_MAPPING_PROPS: 'RESET_CSV_MAPPING_PROPS',
});

const csvMappingsSchema = new schema.Entity(
  'data',
  {},
  { idAttribute: 'csvMappingPropertyDefinitionId' },
);

export const getCsvMappingPropertiesListAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await csvMappingApi.getCsvMappingPropertiesList(params);

  return dispatch({
    type: CSV_MAPPING_ACTION_TYPE.GET_CSV_MAPPING_PROPS,
    payload: normalize(data, [csvMappingsSchema]).entities.data,
  });
});

export const getCsvMappingMetadataAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await csvMappingApi.getCsvMappingMetadata(params);

  return dispatch({
    type: CSV_MAPPING_ACTION_TYPE.GET_CSV_MAPPING_METADATA,
    payload: data,
  });
});

export const editCsvMappingUpdatePropertiesAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await csvMappingApi.editCsvMappingUpdateProperties(params);

    return dispatch({
      type: CSV_MAPPING_ACTION_TYPE.EDIT_CSV_MAPPING_PROPS,
      payload: data,
    });
  },
);

export const createCsvMappingExampleFileAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await csvMappingApi.createCsvMappingExampleFile(params);

  return dispatch({
    type: CSV_MAPPING_ACTION_TYPE.CREATE_CSV_MAPPING_EXAMPLE_FILE,
    payload: data,
  });
});

export const resetCsvMappingPropertiesAction = () => ({
  type: CSV_MAPPING_ACTION_TYPE.RESET_CSV_MAPPING_PROPS,
});
